import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const bluehorseeldConfig: TSPConfig = {
  key: 'bluehorseeld',
  name: 'Bluehorse ELD',
  imageName: 'bluehorseeld',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your Bluehorse ELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default bluehorseeldConfig;
